import {useState} from "react";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import {Modal} from "../../../../components/modal/modal.jsx";
import {regionType} from "../utils/georeferenced-search-utils.js";
import GeoreferencedSearchPlate from "./georeferenced-search-plate.jsx";

const API_URL = import.meta.env.VITE_API_URL;
const GeoreferencedSearchImgModal = ({details, className}) => {
    const [showModal, setShowModal] = useState(false);

    const header =
        <div className="mx-auto">
            <div className="flex w-full justify-center">
                <img src={regionType[details.routeRegionType]}
                     style={{height: "16px", width: "17px", marginRight: "4px"}}
                />
                <span className="font-bold leading-[14px] text-[13px]">{details.capturePlaceName}</span>
            </div>
          {details.laneCode &&
            <div className="flex justify-center">
              <span className="font-normal text-[13px] text-center">{`${details.laneCode} - ${details.routeName}`}</span>
            </div>}
        </div>

    return(
        <div className={className.concat(" cursor-zoom-in")} onClick={() => setShowModal(true)}>
            <TransformWrapper
                wheel={{ step: 0.15 }}
                minScale={1}
                maxScale={5}
                doubleClick={{ disabled: true }}
            >
                <TransformComponent>
                    <img src={`${API_URL}/${details.imageUrl}`}/>
                </TransformComponent>
            </TransformWrapper>
            <Modal title={header} open={showModal} setOpen={setShowModal} className="w-7/12">
                <Modal.Body className="flex flex-col gap-2 items-center bg-[#f7f9fa]">
                    <span>{details.dtCapture}</span>
                    <div className="cursor-zoom-in">
                        <TransformWrapper
                            wheel={{ step: 0.15 }}
                            minScale={1}
                            maxScale={5}
                            doubleClick={{ disabled: true }}
                        >
                            <TransformComponent>
                                <img className="h-[620px]" src={`${API_URL}/${details.imageUrl}`}/>
                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                    <GeoreferencedSearchPlate plate={details.plate}/>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default GeoreferencedSearchImgModal;